module.exports = __webpack_public_path__ + "img/20180815_145537_004.a01b1398.jpg";